import { Button, Typography } from "@hellocarbo/lasagne";
import { Import, Wind } from "lucide-react";
import { useTranslation } from "react-i18next";

import Card from "@/components/ui/Card";

function EmptyView({
  urlNew,
  isScoreReadOnly,
}: {
  urlNew: string;
  isScoreReadOnly: boolean;
}) {
  const { t } = useTranslation("importDeposit");

  return (
    <Card className="mt-sm">
      <Typography step="3" as="h1" weight="semibold">
        {t("importDeposit:title")}
      </Typography>
      <div className="text-center">
        <Wind className="size-md mx-auto" />
        <Typography as="h3" step="1" weight="bold" className="my-2xs">
          {t("importDeposit:newImport.noFileYet")}
        </Typography>
        {!isScoreReadOnly && (
          <Button
            as="a"
            href={urlNew}
            intent="positive"
            shape="soft"
            size="small"
            className="text-center"
          >
            <Import className="size-sm" />
            {t("importDeposit:newImport.importFile")}
          </Button>
        )}
      </div>
    </Card>
  );
}

export default EmptyView;
